import PreDeliveryInspectionConfirmCarDetailsScreen from "../pre-delivery-inspection-confirm-car-details-screen";
import PreDeliveryInspectionFormScreen from "../pre-delivery-inspection-form-screen";
import PreDeliveryInspectionIntent from "../pre-delivery-inspection-intent";
import PreDeliveryInspectionVehicleInfoScreen from "../pre-delivery-inspection-vehicle-info-screen";

export const SCREEN_NAMES = {
    mainFormScreen: "mainFormScreen",
    vehicleInfoScreen: "vehicleInfoScreen",
    confirmCarDetailsScreen: "confirmCarDetailsScreen",
    intentScreen: "intentScreen"
};

export const formScreens = {
    [SCREEN_NAMES.intentScreen]: PreDeliveryInspectionIntent,
    [SCREEN_NAMES.mainFormScreen]: PreDeliveryInspectionFormScreen,
    [SCREEN_NAMES.vehicleInfoScreen]: PreDeliveryInspectionVehicleInfoScreen,
    [SCREEN_NAMES.confirmCarDetailsScreen]: PreDeliveryInspectionConfirmCarDetailsScreen
};
